var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewsletterIcon2 = function SvgNewsletterIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#BB3A90",
    fillOpacity: 0.1,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.572 18.175V37.2c0 1.375-1.125 2.5-2.5 2.5h-12.15a2.507 2.507 0 0 1-2.5-2.5V18.175"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.875 18.175v2.25h8.25v-2.25M28 14.425a1.75 1.75 0 1 0 0 3.501 1.75 1.75 0 0 0 0-3.501Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    d: "M24 22.95a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0 5.675a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    d: "M34.072 40.45h-12.15c-1.8 0-3.25-1.45-3.25-3.25V20.675c0-1.8 1.45-3.25 3.25-3.25h12.175c1.8 0 3.25 1.45 3.25 3.25V37.2c-.025 1.775-1.475 3.25-3.275 3.25Zm-12.15-21.525a1.74 1.74 0 0 0-1.75 1.75V37.2c0 .975.775 1.75 1.75 1.75h12.175a1.74 1.74 0 0 0 1.75-1.75V20.675a1.74 1.74 0 0 0-1.75-1.75H21.922Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#403F3F",
    d: "M23.875 21.175a.68.68 0 0 1-.525-.225.72.72 0 0 1-.225-.525v-2.25c0-.425.325-.75.75-.75h8.25c.425 0 .75.325.75.75v2.25c0 .425-.325.75-.75.75h-8.25Zm.75-2.25v.75h6.75v-.75h-6.75Zm8.125 6.025h-4.5a.737.737 0 0 1-.75-.75c0-.425.325-.75.75-.75h4.5c.425 0 .75.325.75.75s-.325.75-.75.75Zm0 5.625h-4.5a.737.737 0 0 1-.75-.75c0-.425.325-.75.75-.75h4.5c.425 0 .75.325.75.75s-.325.75-.75.75Zm0 5.625h-4.5a.737.737 0 0 1-.75-.75c0-.425.325-.75.75-.75h4.5c.425 0 .75.325.75.75s-.325.75-.75.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB3A90",
    d: "M24.249 37.45c-.25 0-.475-.1-.625-.3l-1.475-1.975a.755.755 0 0 1 .15-1.05.755.755 0 0 1 1.05.15l.875 1.15 1.4-2.125c.225-.35.7-.45 1.05-.2.35.225.45.7.2 1.05l-1.975 2.975c-.125.2-.375.325-.625.35 0-.025-.025-.025-.025-.025Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 18.675a2.507 2.507 0 0 1-2.5-2.5c0-1.375 1.125-2.5 2.5-2.5s2.5 1.125 2.5 2.5-1.125 2.5-2.5 2.5Zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1Z"
  })));
};
export default SvgNewsletterIcon2;